<template>
  <v-container class="custom-container">
    <v-row dense>
      <v-col cols="12">
        <v-card class="" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
          <v-row dense class="align-sm-end justify-center">
            <v-col cols="12" sm="9" md="9">
              <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here ..."
                single-line solo hide-details>
              </v-text-field>
            </v-col>
            <v-col cols="4" sm="3" md="3">
              <v-select solo :items="statusOptions" v-model="status" item-text="text" item-value="value"
                @change="handleSelectStatus" append-icon="mdi-chevron-down" label="Click to Select"
                class="custom-select" hide-details></v-select>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
                  <v-data-table :headers="headers" :items="partnersAgreementsHistories"
                    :server-items-length="pagination?.total || 10" :options.sync="options" :loading="isLoading"
                    :items-per-page="options.itemsPerPage" :footer-props="{
                      'items-per-page-options': [10, 25, 50, 100],
                      'items-per-page-text': 'Rows per page:'
                    }" @update:options="handleOptionsChange" disable-sort>
                    <template v-slot:loading>
                      <div class="d-flex align-center justify-center pa-4">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        <span class="ml-2">Loading data...</span>
                      </div>
                    </template>
                    <template v-slot:no-data>
                      <div class="d-flex align-center justify-center pa-4">
                        <v-icon color="secondary">mdi-information</v-icon>
                        <span class="ml-2">No data found</span>
                      </div>
                    </template>
                    <template v-slot:no-results>
                      <div class="d-flex align-center justify-center pa-4">
                        <v-icon color="secondary">mdi-magnify</v-icon>
                        <span class="ml-2">No matching data found</span>
                      </div>
                    </template>
                    <template v-slot:item.ClientName="{ item }">
                      <router-link class="text-capitalize text--ash" :to="item.ClientNameLink">
                        {{ item.ClientName }}
                      </router-link>
                    </template>

                    <template v-slot:item.DetailsView="{ item }">
                      <a class="links text-decoration-none" target="_blank" rel="noopener noreferrer"
                        :href="item.agreement_file">
                        <v-icon small color="#039de9">
                          mdi-eye-outline
                        </v-icon>
                      </a>
                    </template>

                    <template v-slot:item.agreement_file="{ item }">
                      <a class="links text-decoration-none" target="_blank" rel="noopener noreferrer"
                        :href="item.agreement_file">
                        <img class="mt-2" width="30px" alt="pdf" src="@/assets/pdf-sm.png" />
                      </a>
                    </template>

                    <template v-slot:item.ApprovalView="{ item }">
                      <div class="status-selection agreement-status-selection">
                        <v-select solo :items="slots" append-icon="mdi-chevron-down" class="custom-select"
                          :value="item.status" item-text="text" item-value="value"
                          @change="(newStatus) => handleUpdateStatus(item, newStatus)">
                          <template v-slot:selection="{ item }">
                            <div :class="getTextColor(item)">
                              {{ item.text }}
                            </div>
                          </template>
                        </v-select>
                      </div>
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import {
    AGREEMENTS__ACTIONS
} from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      isLoading: false,
      status: null,
      search: "",
      searchTimeout: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      imageUrl: null,
      statusOptions: [
        { text: "All", value: -1 },
        { text: "Approved", value: 1 },
        { text: "Declined", value: 2 },
        { text: "Pending", value: 0 }
      ],
      slots: [
        { text: "Approved", value: 1, class: "text-approved" },
        { text: "Declined", value: 2, class: "text-decline" },
        { text: "Pending", value: 0, class: "text-pending" },
      ],
      headers: [
        { text: "Date & Time", value: "updated_at", align: "start" },
        { text: "T&C For", value: "title" },
        { text: "Client Name", value: "client" },
        { text: "PDF", value: "agreement_file" },
        { text: "Approval", value: "ApprovalView" },
        { text: "Detail", value: "DetailsView" },
      ],
    };
  },

  computed: {
    ...mapState("agreements", ["partnersAgreementsHistories"]),
  },

  methods: {
    ...mapActions("agreements", [
      AGREEMENTS__ACTIONS.UPDATECLIENTSAGREEMENTSTATUS,
      AGREEMENTS__ACTIONS.GETPARTNERSAGREEMENTSHISTORIES,
    ]),

    handleUpdateStatus(item, status) {
      this[AGREEMENTS__ACTIONS.UPDATECLIENTSAGREEMENTSTATUS]({
        id: item.id,
        status,
      });
    },

    getTextColor(item) {
      return item.class;
    },

    async fetchData() {
      try {
        this.isLoading = true
        const params = {
          page: this.options.page || 1,
          limit: this.options.itemsPerPage || 10,
          search: this.search,
          status: this.status === 0 ? "0" :this.status === -1 ? null: this.status,
        };

        await this[AGREEMENTS__ACTIONS.GETPARTNERSAGREEMENTSHISTORIES](params);
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },


    async handleSearch() {
      await this.fetchData();
    },

    async handleSelectStatus() {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleOptionsChange(options) {
      this.fetchData();
    },
  },
  async created() {
    await this.fetchData()
  },
};
</script>
